import React, { useState } from "react";
import reject from "ramda/src/reject";
import propEq from "ramda/src/propEq";
import { L2Selector } from "../../common/network/NetworkSelectors";
import { UserRemoveResultsTable } from "../../components/UserRemoveResultsTable";
import useAuth from "../login/AuthContext";

import { Typography } from "../../UI/Typography";

import { useNetwork } from "../../hooks/useNetwork";
import { MainLayout } from "../../layout/MainLayout";
import { Grid } from "../../UI/Grid";
import { RequestSubnetworkClearButton } from "../../components/RequestSubnetworkClearButton";
import { ModalProvider } from "../../contexts/ModalContext";
import { UserSearchByNameForm } from "../../components/UserSearchByNameForm";
import { UserSearchByUserIdForm } from "../../components/UserSearchByUserIdForm";

export const UsersRemovePage = () => {
  const [subnetwork, setSubnetwork] = useState(null);
  const { selectedNetwork, getL2Options } = useNetwork();
  const { isSuperAdmin, isWriteAccess } = useAuth();
  const [results, setResults] = React.useState([]);

  const removeResult = (id) => () => setResults(reject(propEq("id", id)));

  const numberOfNetworksWithUsers = getL2Options(selectedNetwork.l1Id).filter((x) => x.usersInNetwork > 0).length;

  return (
    <MainLayout title="Remove Specific User">
      {isWriteAccess() && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <UserSearchByNameForm onSuccess={setResults} />
          </Grid>
          {isSuperAdmin() && (
            <Grid item xs={12}>
              <UserSearchByUserIdForm onSuccess={setResults} />
            </Grid>
          )}
          <Grid item xs={12} my={4}>
            <UserRemoveResultsTable results={results} onSuccess={removeResult} />
          </Grid>
          {isSuperAdmin() && (
            <Grid item container spacing={2} alignItems="end">
              <Grid item xs={12}>
                <Typography gutterBottom variant="h6">
                  Remove All Users from a Matching Round
                </Typography>
              </Grid>
              {numberOfNetworksWithUsers > 0 && (
                <>
                  <Grid item xs>
                    <L2Selector onSelectHandler={setSubnetwork} filter={(x) => x.usersInNetwork > 0} />
                  </Grid>
                  <Grid item xs pb={0.5}>
                    <ModalProvider>
                      <RequestSubnetworkClearButton subnetwork={subnetwork} />
                    </ModalProvider>
                  </Grid>
                </>
              )}
              {numberOfNetworksWithUsers <= 0 && (
                <Grid item>
                  <Typography variant="body2">No Subnetwork with users</Typography>
                </Grid>
              )}
            </Grid>
          )}
        </Grid>
      )}
    </MainLayout>
  );
};

export const USERS_REMOVE_URL = "/users/remove";
